export const DiscountUnit = {
    AMOUNT: "원",
    PERCENT: "%",
} as const;
